import { useState, useEffect } from "react";
import Navbar from "./components/Navbar";
import Sidebar from "./components/Sidebar";
import Main from "./components/Main";
import { Analytics } from "@vercel/analytics/react";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import {
  BrowserRouter,
  Routes, // instead of "Switch"
  Route,
} from "react-router-dom";
import Welcome from "./components/Welcome";
import Developers from "./components/Developers";
import Info from "./components/Info";

const darkTheme = createTheme({
  palette: {
    mode: "dark",
  },
});

// Moved outside the component so it's a true constant and doesn't trigger re-renders.
const validThemes = ["default"];

function App() {
  const [page, setPage] = useState("Grind");
  const [resultN, setResultN] = useState(null);

  // Read the selected theme from local storage on page load
  const initialThemeClass = localStorage.getItem("selectedTheme") || "default";
  const [themeClass, setThemeClass] = useState(initialThemeClass);

  useEffect(() => {
    // Check if the theme in local storage is valid, and if not, switch to the default theme
    if (!validThemes.includes(initialThemeClass)) {
      setThemeClass("default");
    }
  }, [initialThemeClass]);

  const changeTheme = (themeName) => {
    if (validThemes.includes(themeName)) {
      setThemeClass(themeName);
      // Save the selected theme to local storage if it's a valid theme
      localStorage.setItem("selectedTheme", themeName);
    }
  };

  return (
    <ThemeProvider theme={darkTheme}>
      <BrowserRouter>
        <Routes>
          <Route
            path="/calculator"
            element={
              <div className={`${themeClass}`}>
                <div
                  className={`text-white flex items-center flex-col justify-center h-screen w-screen`}
                >
                  <div className="text-white mt-8">
                    <Navbar />
                  </div>
                  <Main
                    resultN={resultN}
                    page={page}
                    setPage={setPage}
                    themeClass={themeClass}
                    changeTheme={changeTheme} // Pass the function to <Main>
                  />
                  <Analytics />
                </div>
                <Sidebar
                  themeClass={themeClass}
                  page={page}
                  setPage={setPage}
                  setResultN={setResultN}
                />
              </div>
            }
          />
          <Route path="/" element={<Welcome themeClass={themeClass} changeTheme={changeTheme} />} />
          <Route path="/developers" element={<Developers themeClass={themeClass} changeTheme={changeTheme} />} />
          <Route path="/info" element={<Info themeClass={themeClass} changeTheme={changeTheme} />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;